import { create } from "zustand";
import { BlogPost, BlogDraft } from "../types/blog";

interface BlogStore {
  posts: BlogPost[];
  drafts: BlogDraft[];
  setPosts: (posts: BlogPost[]) => void;
  addPost: (post: BlogPost) => void;
  updatePost: (id: string, updates: Partial<BlogPost>) => void;
  deletePost: (id: string) => void;
  addDraft: (draft: BlogDraft) => void;
  updateDraft: (id: string, updates: Partial<BlogDraft>) => void;
  deleteDraft: (id: string) => void;
}

export const useBlogStore = create<BlogStore>((set) => ({
  posts: [],
  drafts: [],
  setPosts: (posts: BlogPost[]) => set({ posts }),
  addPost: (post) => set((state) => ({ posts: [...state.posts, post] })),
  updatePost: (id, updates) =>
    set((state) => ({
      posts: state.posts.map((p) => (p.id === id ? { ...p, ...updates } : p)),
    })),
  deletePost: (id) =>
    set((state) => ({
      posts: state.posts.filter((p) => p.id !== id),
    })),
  addDraft: (draft) => set((state) => ({ drafts: [...state.drafts, draft] })),
  updateDraft: (id, updates) =>
    set((state) => ({
      drafts: state.drafts.map((d) => (d.id === id ? { ...d, ...updates } : d)),
    })),
  deleteDraft: (id) =>
    set((state) => ({
      drafts: state.drafts.filter((d) => d.id !== id),
    })),
}));
